// extracted by mini-css-extract-plugin
export var actionText = "_mz-4";
export var container = "_mz-0";
export var leftSection = "_mz-1";
export var rightSection = "_mz-2";
export var settingsButton = "_mz-6";
export var settingsIcon = "_mz-7";
export var shortcut = "_mz-5";
export var shortcutGroup = "_mz-3";